<template>
    <div class="specialDetaidBox">
        <MaskLoading v-if="isShow"></MaskLoading>
        <!-- <banner :bannerList="bannerList"></banner> -->
        <img src="../../assets/special/db7.jpg" alt="" class="mobileImg" v-if="isMobile">
        <img src="../../assets/special/db7_pc.jpg" alt="" class="mobileImg" v-else>
        <!--  -->
        <div class="special_warpper">
            <div class="p20">
                <backSpecial></backSpecial>
                <div>
                    <div class="arrow_box mb20">
                        <div class="arrow_title">理赔流程</div>
                        <div>
                            <img src="../../assets/special/d7t.jpg" alt="" style="width:100%;display: block;"
                                v-if="isMobile">
                            <img src="../../assets/special/d7t_pc.jpg" alt="" style="width:100%;display: block;" v-else>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">保障內容</div>
                    <div class="table_box mb20">
                        <div class="tab_title_box">
                            <div class="tab_title">
                                <div class="flex flex_warp juc" style="height:100%">
                                    <div style="line-height:normal">保障项目</div>
                                </div>
                            </div>
                            <div class="tab_title">
                                <div class="flex flex_warp juc" style="height:100%">
                                    <div style="line-height:normal">保障内容</div>
                                </div>
                            </div>
                            <div class="tab_title">
                                <div class="flex flex_warp juc" style="height:100%">
                                    <div style="line-height:normal">最高互助金额</div>
                                </div>
                            </div>
                        </div>
                        <div class="table_info_box">
                            <div class="row_list">
                                <div class="tab_cell">意外伤害</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">因意外事故导致的伤残和身故</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">100000元</div>
                            </div>
                            <div class="row_list">
                                <div class="tab_cell">意外医疗</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">门诊、住院“自付一”费用(免赔额100元)</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">10000元</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">申领材料</div>
                    <div class="desc mb20">
                        1、会员本人的身份证、工会会员互助服务卡复印件。<br>
                        2、申请领取伤残互助金时,应同时提供由二级(含)以上医疗机构出具的伤残程度证明,如诊断证明、住院病案首页、入院记录、手术记录、出院记录(加盖病案室复印专用章)、影像报告等。如果会员自遭受意外伤害之日起180日治疗仍未结束,则按照第180日的身体伤残状况出具相应证明。<br>
                        3、申请领取意外医疗互助金时,会员应同时提供由二级(含)以上医疗机构出具的伤残程度证明、北京市门诊收费专用收据和北京市医疗保险住院费用清单复印件医疗费用报销分割单等。<br>
                        4、申请领取身故互助金时,会员亲属应同时提供医疗机构或事故处理机关出具的死亡证明。
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">温馨提示</div>
                    <div class="desc mb20">
                        1、本活动保障期限为10天。<br>
                        2、会员自意外事故发生之日起,两年内未提交互助金申领手续的,视同为放弃申请互助金的权利。
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">咨询电话</div>
                    <footerTel tel="010-67685602"></footerTel>
                </div>

                <div class="footer ">本页面仅供参考,具体以北京市职工互助保障服务中心公示细则为准</div>
            </div>
        </div>
        <!-- 弹层 -->
        <el-drawer title="以下情况需提供补充申报材料" size="50%" custom-class="custom-class" :visible.sync="drawer"
            :direction="direction">
            <div class="drawer_box">
                <div class="img_box">
                    <img src="../../assets/special/d4.jpg" alt="" class="drawer_img">
                </div>
            </div>
        </el-drawer>
        <!--  -->
    </div>
</template>

<script>
// import banner from "../../components/banner.vue"
import MaskLoading from "@/components/maskLoading.vue";
import Mixins from "../../script/getMobile";
import backSpecial from "@/components/backSpecial.vue"
import footerTel from "@/components/specialFooterTel.vue"
export default {
    name: "",
    mixins: [Mixins],
    data() {
        return {
            isShow: true,
            drawer: false,
            direction: 'btt',
            bannerList: [
                { "src": require("@/assets/special/baoxiao.jpg") },
                // { "src": require("@/assets/special/baoxiao.jpg") }
            ],
        }
    },
    components: {
        // banner,
        MaskLoading,
        backSpecial,
        footerTel
    },
    mounted() {
        setTimeout(() => {
            this.isShow = false;
        }, 200)
    },
    methods: {
        showDrawer() {
            this.drawer = true;
        }
    },
    activated() {
        window.scrollTo(0, 0);
    },
    deactivated() {
        this.drawer = false;
    }
}
</script>

<style lang="less" scoped>
@import url(../../styles/specialDetail.less);

.specialDetaidBox {
    .arrow_title {
        background-color: #EDF5FC;
    }

    .table_box {

        border: 1px solid #eaeff3;
        overflow: hidden;

        .tab_title_box {
            display: flex;
            flex-wrap: wrap;

            .tab_title {
                flex: 1;
                text-align: center;
                background-color: #eff8ff;
                line-height: 40px;
                font-size: 13px;
                font-weight: bold;
                border-left: 1px solid #ededed;
                border-bottom: 1px solid #ededed;
                margin-left: -1px;
                overflow: hidden;
                padding-top: 10px;
                padding-bottom: 10px;
            }
        }


        .table_info_box {
            // display: flex;
            // flex-wrap: wrap;

            .tab_cell {
                flex: 1;
                font-size: 12px;
                text-align: center;
            }

            .row_list {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                width: 100%;
                height: 60px;
                border-bottom: 1px solid #ededed;
                margin-bottom: -1px;
            }

            .sLine {
                width: 1px;
                background-color: #ededed;
                height: 60px;
            }

            .bb1 {
                border-bottom: 1px solid #ededed;
                box-sizing: border-box;
            }

        }



    }
}
</style>